import React, {lazy} from "react";
import {Provider} from "react-redux";
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";
import store from "modules/store";
import {
	Content,
	Footer,
	Header,
	NotAuthOnlyRoute,
	Preloader,
	PrivateRoute,
	Session,
	HOCSSO,
	ModalError,
	ModalReturningUser,
	ModalRegisterForGame,
	AdvertRectangle,
	HOCCrossPromotion,
	HocI18n,
} from "components";
import {Constant, User} from "modules/utils";
import {retryFailLoad} from "modules/utils/lazy_load";
import {createTheme, ThemeProvider} from "@mui/material";

const Landing = lazy(retryFailLoad(() => import("pages/Landing")));
const Backdoor = lazy(retryFailLoad(() => import("pages/Backdoor")));
const Registration = lazy(retryFailLoad(() => import("pages/Registration")));
const Team = lazy(retryFailLoad(() => import("pages/Team")));
const Leagues = lazy(retryFailLoad(() => import("pages/Leagues")));
const StatsCentre = lazy(retryFailLoad(() => import("pages/StatsCentre")));
const Help = lazy(retryFailLoad(() => import("pages/Help")));
const Prizes = lazy(retryFailLoad(() => import("pages/Prizes")));
const CreateLeague = lazy(retryFailLoad(() => import("pages/leagues/CreateLeague")));
const JoinLeagues = lazy(retryFailLoad(() => import("pages/leagues/JoinLeagues")));
const LeagueRankings = lazy(retryFailLoad(() => import("pages/leagues/LeagueRankings")));
const NotFound = lazy(retryFailLoad(() => import("pages/NotFound")));
const Login = lazy(retryFailLoad(() => import("pages/Login")));
const Logout = lazy(retryFailLoad(() => import("pages/Logout")));

const IS_PRODUCTION = Constant.ENV === "production";
const theme = createTheme({
	palette: {
		mode: "dark",
	},
});

export const AppComponent = () => (
	<Provider store={store}>
		<Router>
			<HocI18n>
				<ThemeProvider theme={theme}>
					<Header />
					<HOCCrossPromotion>
						<Content>
							<HOCSSO>
								<React.Suspense fallback={<Preloader />}>
									<Session>
										<Switch>
											<NotAuthOnlyRoute
												exact={true}
												path="/"
												component={Landing}
											/>
											<NotAuthOnlyRoute path="/login" component={Login} />
											{User.IS_SECRET_PASSED() ? (
												<Switch>
													{IS_PRODUCTION ? null : (
														<Route
															exact={true}
															path="/backdoor"
															component={Backdoor}
														/>
													)}
													<NotAuthOnlyRoute
														exact={true}
														path="/registration"
														component={Registration}
													/>
													<PrivateRoute
														exact={true}
														path="/team/:event_id?"
														component={Team}
													/>
													<PrivateRoute
														exact={true}
														path="/leagues"
														component={Leagues}
													/>
													<PrivateRoute
														exact={true}
														path="/leagues/create"
														component={CreateLeague}
													/>
													<PrivateRoute
														exact={true}
														path="/leagues/join"
														component={JoinLeagues}
													/>
													<PrivateRoute
														exact={true}
														path="/leagues/join/:code"
														component={JoinLeagues}
													/>
													<PrivateRoute
														exact={true}
														path="/leagues/:id/rankings"
														component={LeagueRankings}
													/>
													<PrivateRoute
														exact={true}
														path="/stats-centre"
														component={StatsCentre}
													/>
													<Route
														exact={true}
														path="/help/:section?"
														component={Help}
													/>
													<Route
														exact={true}
														path="/Prizes"
														component={Prizes}
													/>
													<PrivateRoute
														exact={true}
														path="/logout"
														component={Logout}
													/>
													<Route path="*" component={NotFound} />
												</Switch>
											) : (
												<Redirect to={"/"} />
											)}
										</Switch>
										<AdvertRectangle />
									</Session>
								</React.Suspense>
							</HOCSSO>
						</Content>
						<Footer />
					</HOCCrossPromotion>
					<ModalError />
					<ModalReturningUser />
					<ModalRegisterForGame />
				</ThemeProvider>
			</HocI18n>
		</Router>
	</Provider>
);

export default AppComponent;
